import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
  capture_pageview: true, // Automatically capture pageviews
  capture_pageleave: true, // Track when users leave pages
  session_recording: {
    enabled: true, // Enable session recordings
    maskAllInputs: true, // Mask sensitive input data
    maskInputOptions: {
      password: true,
      email: false,
    },
  },
  person_profiles: 'identified_only', // Track user profiles when identified
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Only enable PostHog in production
const AppWithAnalytics = process.env.NODE_ENV === 'production' ? (
  <PostHogProvider 
    apiKey={process.env.REACT_APP_POSTHOG_KEY} 
    options={options}
  >
    <App />
  </PostHogProvider>
) : (
  <App />
);

root.render(
  <React.StrictMode>
    {AppWithAnalytics}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
